module.exports = __webpack_public_path__ + "assets/full_screen_icon.1721d1e8.svg";